import { render, staticRenderFns } from "./Courses_done.vue?vue&type=template&id=0354a559&scoped=true&"
import script from "./Courses_done.vue?vue&type=script&lang=js&"
export * from "./Courses_done.vue?vue&type=script&lang=js&"
import style0 from "./Courses_done.vue?vue&type=style&index=0&id=0354a559&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354a559",
  null
  
)

export default component.exports